import { render, staticRenderFns } from "./AdminSubMenu.vue?vue&type=template&id=66ff7876&scoped=true&"
import script from "./AdminSubMenu.vue?vue&type=script&lang=js&"
export * from "./AdminSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminSubMenu.vue?vue&type=style&index=0&id=66ff7876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff7876",
  null
  
)

export default component.exports